var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HandProtection50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.5,14c-0.828,0-1.5,0.672-1.5,1.5V21l-2-0.167V11.5c0-0.828-0.672-1.5-1.5-1.5S27,10.672,27,11.5 v9.083l-2-0.167V10.5C25,9.672,24.328,9,23.5,9S22,9.672,22,10.5v9.667L20,20v-8.5c0-0.828-0.672-1.5-1.5-1.5S17,10.672,17,11.5V24 c0,0-2.592-3.421-2.615-3.443c-0.701-0.674-1.807-0.753-2.602-0.144C11.27,20.806,11,21.4,11,22c0,0.254,0.048,0.509,0.146,0.75 C11.163,22.792,11.702,24.097,14,29c1.875,4,3,4,3,4l-1,5h18l-1-5c0,0,2-1,2-6c0-0.356,0-11.5,0-11.5C35,14.672,34.328,14,33.5,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HandProtection50);
export default __webpack_public_path__ + "static/media/icons8-hand-protection-50.e9f6e372b50048384249dbcdd781a7a1.svg";
export { ForwardRef as ReactComponent };